import Cookies from 'quasar/src/plugins/cookies/Cookies.js';
export class CookieHelper {
    static exist(key) {
        return Cookies.has(key);
    }
    static get(key) {
        if (!this.exist(key)) {
            return "";
        }
        return Cookies.get(key);
    }
    static set(key, value) {
        Cookies.set(key, value);
    }
    static getArray(key) {
        if (!this.exist(key)) {
            return [];
        }
        let json = Cookies.get(key);
        if (json === null) {
            return [];
        }
        // QuasarのCookies.getの戻りが、公式Docだとstring | null、ソース上だと{} | nullになってるので、JSON.parseするとおかしくなる。
        // 一応typeみて、objectならそのまま返却、それ以外だったらJSON.parseしてみる形にしとく
        if (typeof json === "object") {
            return json;
        }
        try {
            return JSON.parse(json);
        }
        catch (ex) {
            console.error(ex);
            return [];
        }
    }
    static setArray(key, array) {
        Cookies.set(key, JSON.stringify(array), { sameSite: "Lax", expires: 2147483647 });
    }
    static addArrayItem(key, item, maxSize = null) {
        if (Cookies.get(key) == null || !Cookies.get(key)?.includes(item)) {
            let array = this.getArray(key);
            array.push(item);
            if (maxSize != null && array.length >= maxSize) {
                array.shift();
            }
            this.setArray(key, array);
        }
    }
}
